import React from 'react';
import './Modal.css';

import x from "../../../../asset/x.svg";

const Modal = ({ image, onClose }) => {
  return (
    <div className="design-modal-container" onClick={onClose}>
      <div className="design-modal-upper">
          <img
              src={x}
              alt={"x"}
              onClick={onClose}
              className="design-modal-upper-x"
              style={{
                  width: "auto",
                  height: "20px",
                  margin: "2%"
              }}
          />
      </div>
      <div className="design-modal-lower" onClick={(e) => e.stopPropagation()}>
        <img src={image} alt={"modal-image"} className="design-modal-image" />
      </div>
      <div className="design-modal-bottom">
      </div>
    </div>
  );
};

export default Modal;